<script>
  import { Scatter } from 'vue-chartjs'
  export default {
    extends: Scatter,
    name: 'scatterChart',
    props: ['data', 'options'],
    mounted () {
      this.renderChart(this.data, this.options)
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/results/ScatterChart.vue